import { render, staticRenderFns } from "./CustomerPasswordReset.vue?vue&type=template&id=23763caa"
import script from "./CustomerPasswordReset.vue?vue&type=script&lang=js"
export * from "./CustomerPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports